import { render, staticRenderFns } from "./GloriousHistory.vue?vue&type=template&id=70b4490a&scoped=true&"
import script from "./GloriousHistory.vue?vue&type=script&lang=js&"
export * from "./GloriousHistory.vue?vue&type=script&lang=js&"
import style0 from "./GloriousHistory.vue?vue&type=style&index=0&id=70b4490a&prod&scoped=true&lang=css&"
import style1 from "./GloriousHistory.vue?vue&type=style&index=1&id=70b4490a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b4490a",
  null
  
)

export default component.exports